import React, {Suspense} from 'react'
import * as PropTypes from 'prop-types'
import {InferPropTypes} from '@modifi/typescript-utils'
import {CustomerExistingFilesList} from '@modifi/plugin-documents'
import {useRenderPersistedArray} from '../../../../../../hooks'
import {existingFilesListComponents} from './components'

const propTypes = {
  fileIds: PropTypes.arrayOf(PropTypes.string.isRequired).isRequired,
}
const defaultProps = {}

type DocumentListProps = InferPropTypes<typeof propTypes, typeof defaultProps>

const DocumentList: React.FC<DocumentListProps> = ({fileIds: fileIdsProp}) => {
  const fileIds = useRenderPersistedArray(fileIdsProp)
  return (
    <Suspense fallback={null}>
      <CustomerExistingFilesList fileIds={fileIds} components={existingFilesListComponents} />
    </Suspense>
  )
}

DocumentList.propTypes = propTypes
DocumentList.defaultProps = defaultProps

export default React.memo(DocumentList)
